import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isWebComponentEnvironment } from '@/helpers';
import { detectTargetDeviceThunk } from '@/actions';
import {
  useSelectAll,
  useSelectWithArrows,
  useUndo,
  useSwitchNextSection,
  useDuplicateContent,
  useIncrementN,
} from '@/hooks';
import { uploadMaterialThunk } from '@/store/actions/cmme';
import App from './App';

const Container = () => {
  const dispatch = useDispatch();
  const webComponent = isWebComponentEnvironment();

  useSelectAll();
  useSelectWithArrows();
  useSwitchNextSection();
  useUndo();
  useDuplicateContent();
  useIncrementN();

  useEffect(() => {
    dispatch(detectTargetDeviceThunk());
    if (webComponent) {
      dispatch(uploadMaterialThunk());
    }
  }, []);

  return <App />;
};

export default Container;
